import { ROLES } from "./roles";

// PRODUCT_OWNER is the platform super admin. THREE_PL_OWNER is a warehouse
// (tenant) admin: full access, but the backend scopes all data to their warehouse.
const OWNER = [ROLES.PRODUCT_OWNER];
const TPO = ROLES.THREE_PL_OWNER;
const WM = ROLES.WAREHOUSE_MANAGER;
const WS = ROLES.WAREHOUSE_STAFF;
const VAO = ROLES.VA_AGENCY_OWNER;
const VAM = ROLES.VA_MANAGER;
const VAS = ROLES.VA_STAFF;
const CL = ROLES.CLIENT;

// module key -> { read:[roles], write:[roles] }. Owner roles are always allowed.
export const MODULE_POLICY = {
  dashboard: { read: [TPO, WM, WS, VAO, VAM, VAS, CL], write: [] },
  orders: { read: [TPO, WM, WS, VAO, VAM, VAS, CL], write: [TPO, WM, WS, VAO, VAM, VAS] },
  inbound: { read: [TPO, WM, WS], write: [TPO, WM, WS] },
  inventory: { read: [TPO, WM, WS, VAO, VAM, VAS, CL], write: [TPO, WM, WS] },
  returns: { read: [TPO, WM, WS, CL], write: [TPO, WM, WS] },
  clients: { read: [TPO, WM], write: [TPO] },
  stores: { read: [TPO, WM, VAO, VAM, VAS, CL], write: [TPO] },
  users: { read: [TPO], write: [TPO] },
  "va-agencies": { read: [TPO], write: [TPO] },
  warehouses: { read: [], write: [] },
  invoicing: { read: [TPO, WM], write: [TPO, WM] },
  "activity-log": { read: [TPO, WM], write: [] },
  settings: { read: [], write: [] },
};

export function isOwnerRole(role) {
  return OWNER.includes(role);
}

export function canAccessModule(role, moduleKey) {
  if (!role) return false;
  if (isOwnerRole(role)) return true;
  const pol = MODULE_POLICY[moduleKey];
  if (!pol) return true;
  return pol.read.includes(role);
}

export function canWrite(role, moduleKey) {
  if (!role) return false;
  if (isOwnerRole(role)) return true;
  const pol = MODULE_POLICY[moduleKey];
  if (!pol) return true;
  return pol.write.includes(role);
}

export function can(role, moduleKey, action = "read") {
  return action === "write" ? canWrite(role, moduleKey) : canAccessModule(role, moduleKey);
}
